<template>
  <div class="container">
    <Header ></Header>
    <router-view ></router-view>
    <Footer></Footer>
  </div>
</template>


<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  setup() {
    return {
    }
    }
}
</script>

<style>
@import 'assets/styles.css';
</style>
